import {
    addLocaleData
} from 'react-intl';

import {
    localeData
} from 'scratch-l10n';
// import editorMessages from 'scratch-l10n/locales/editor-msgs';
import editorMessages from 'scratch-blocks/msg/locales/client_data.js';
import {
    isRtl
} from 'scratch-l10n';

addLocaleData(localeData);

const defaultMessages = window.localesArray || editorMessages;

const UPDATE_LOCALES = 'scratch-gui/locales/UPDATE_LOCALES';
const SELECT_LOCALE = 'scratch-gui/locales/SELECT_LOCALE';
const initialState = {
    isRtl: false,
    locale: 'en',
    messagesByLocale: defaultMessages,
    messages: defaultMessages.en
};
const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
        case SELECT_LOCALE:
            return Object.assign({}, state, {
                isRtl: isRtl(action.locale),
                locale: action.locale,
                messagesByLocale: state.messagesByLocale,
                messages: state.messagesByLocale[action.locale]
            });
        case UPDATE_LOCALES:
            return Object.assign({}, state, {
                isRtl: state.isRtl,
                locale: state.locale,
                messagesByLocale: action.messagesByLocale,
                messages: action.messagesByLocale[state.locale]
            });
        default:
            return state;
    }
};

const selectLocale = function (locale) {

    localStorage.setItem('language', locale); // 将选择语言存在localstorage中，用于打开的时候载入
    // if (typeof (jsObj) === 'object'){
    //     let json = {
    //         command: 'GEN_SETDEFAULTLANGUAGE',
    //         language: locale
    //     };
    //     json = JSON.stringify(json);
    //     jsObj.SendToBrowser(json);
    //     // 手动更改lang的值，lang定义在get.js文件中
    //     lang = locale;
    // }
    return {
        type: SELECT_LOCALE,
        locale: locale
    };
};

const setLocales = function (localesMessages) {
    return {
        type: UPDATE_LOCALES,
        messagesByLocale: localesMessages
    };
};
const initLocale = function (currentState, locale) {
    if (currentState.messagesByLocale.hasOwnProperty(locale)) {
        return Object.assign({},
            currentState, {
                isRtl: isRtl(locale),
                locale: locale,
                messagesByLocale: currentState.messagesByLocale,
                messages: currentState.messagesByLocale[locale]
            }
        );
    }
    // don't change locale if it's not in the current messages
    return currentState;
};
export {
    reducer as
    default,
    initialState as localesInitialState,
    initLocale,
    selectLocale,
    setLocales
};
